import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/category/CategoryPageContent.tsx");
